import type { IUseCase } from 'shared-kernel';
import type { IAuthRepository } from '../../../domain/ports';
import type { ChangeEmailData } from '../../dto/dtos';

export class ChangeEmailUseCase implements IUseCase<ChangeEmailData, void> {
  constructor(
    private readonly authRepository: IAuthRepository,
  ) {}

  async execute(input: ChangeEmailData): Promise<void> {
    const response = await this.authRepository.changeEmail(input);

    if (!response.succes) {
      throw new Error(response.message || 'Echec du changement d\'email');
    }
  }
}
